<template>
  <header :class="['fp-nav', `fp-nav--${theme}`]">
    <div class="fp-nav__inner">
      <router-link to="/" class="fp-nav__logo-link">
        <img
          class="fp-nav__logo"
          :src="logoSrc"
          alt="BOX21"
          height="38"
        />
      </router-link>

      <nav v-if="showLinks" class="fp-nav__links">
        <router-link v-if="showDesignsLink" to="/designs" class="fp-nav__link fp-nav__link--designs">All designs</router-link>
        <router-link v-if="showTeamLink" to="/team" class="fp-nav__link">Team</router-link>
        <button type="button" class="fp-nav__link fp-nav__link--btn" @click="goToRegister">
          Register
        </button>
        <button
          type="button"
          :class="['fp-nav__cta', { 'fp-nav__cta--outline': ctaOutline }]"
          @click="goToLogin"
        >
          Login
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
import { BRAND, SHOW_TEAM_LINK } from '@/components/front_page/designs/shared'

export default {
  name: 'FrontPageDesignNav',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: (v) => ['light', 'dark', 'transparent'].includes(v),
    },
    showLinks: { type: Boolean, default: true },
    showDesignsLink: { type: Boolean, default: true },
    showTeamLink: { type: Boolean, default: SHOW_TEAM_LINK },
    ctaOutline: { type: Boolean, default: false },
    logoSrc: { type: String, default: BRAND.logo },
  },
  methods: {
    goToLogin() {
      this.$router.push('/login')
    },
    goToRegister() {
      this.$router.push({ path: '/login', query: { tab: 'register' } })
    },
  },
}
</script>

<style scoped>
.fp-nav {
  position: relative;
  z-index: 20;
  width: 100%;
}

.fp-nav__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
}

.fp-nav__logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.fp-nav__logo {
  display: block;
  height: 38px;
  width: auto;
}

.fp-nav__links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fp-nav__link {
  font-size: 0.95rem;
  text-decoration: none;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}

.fp-nav__cta {
  font-size: 0.95rem;
  padding: 10px 20px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.fp-nav__cta:hover {
  transform: translateY(-1px);
}

.fp-nav--light .fp-nav__link {
  color: #46423a;
}

.fp-nav--light .fp-nav__cta {
  background: #0677b9;
  color: #fff;
}

.fp-nav--light .fp-nav__cta--outline {
  background: transparent;
  border: 2px solid #0677b9;
  color: #0677b9;
}

.fp-nav--dark .fp-nav__link,
.fp-nav--transparent .fp-nav__link {
  color: rgba(255, 255, 255, 0.85);
}

.fp-nav--dark .fp-nav__link:hover,
.fp-nav--transparent .fp-nav__link:hover {
  color: #fff;
}

.fp-nav--dark .fp-nav__cta,
.fp-nav--transparent .fp-nav__cta {
  background: #fff;
  color: #0677b9;
}

.fp-nav--dark .fp-nav__cta--outline,
.fp-nav--transparent .fp-nav__cta--outline {
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.7);
  color: #fff;
}

.fp-nav--transparent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

@media (max-width: 600px) {
  .fp-nav__links .fp-nav__link--designs {
    display: none;
  }
}
</style>
